import React from 'react';
import { isBuiltInWebsiteLogo } from './themeRuntime';

type BrandLockupProps = {
  path: string;
  variant?: 'header' | 'footer';
  imageClassName?: string;
};

export default function BrandLockup({ path, variant = 'header', imageClassName }: BrandLockupProps) {
  if (!isBuiltInWebsiteLogo(path)) {
    return (
      <img
        src={path}
        alt="NextCompli"
        className={imageClassName || (variant === 'footer' ? 'footer-lockup-image' : 'brand-lockup-image')}
      />
    );
  }

  return (
    <span className={`brand-lockup brand-lockup-${variant}`}>
      <svg className="brand-lockup-mark" viewBox="0 0 48 48" aria-hidden="true">
        <circle cx="24" cy="26" r="14.25" fill="none" stroke="currentColor" strokeWidth="2.7" />
        <path
          d="M6.5 39.5 L20.2 18.2 L28.2 29.6 L42.6 8.1"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M46 2.9 L45.2 9.8 L39.9 6.3 Z" fill="currentColor" />
      </svg>
      <span className="brand-lockup-words">
        <span className="brand-lockup-name">NextCompli</span>
        <span className="brand-lockup-tagline">Intelligent Software for a Compliant Future</span>
      </span>
    </span>
  );
}
